import script from "./MsTourGuide.vue?vue&type=script&setup=true&lang=js"
export * from "./MsTourGuide.vue?vue&type=script&setup=true&lang=js"

import "./MsTourGuide.vue?vue&type=style&index=0&id=a756b2f0&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-a756b2f0"]])

export default __exports__